import type { NextPage } from 'next'
import Head from 'next/head'
import { Layout, Main } from 'layout'
import PageContentService from 'pageContent/Service'

const Service: NextPage = () => (
  <Layout>
    <Head>
      <title>Anfahrt und Service | FrauenCoach</title>
      <meta name="description" content={`Wie komme ich zur Praxis von FrauenCoach.jetzt? ● Zentral in Berlin Mitte ● Anfahrt ● Verkehrsmittel ● Umgebung`} />
    </Head>
    <Main>
      <PageContentService />
    </Main>
  </Layout>
)

export default Service
